import { AuditTrailEvent } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, OffsetPaginatedResource, OffsetPaginationParams } from '@sonar-software/sonar-ts-types';

export type GetSetupAuditTrailRequest = OffsetPaginationParams & DynamicQueryParams;

export type GetSetupAuditTrailResponse = OffsetPaginatedResource<AuditTrailEvent>;

export const getSetupAuditTrailEvents = createGetEndpoint<GetSetupAuditTrailRequest, GetSetupAuditTrailResponse>(
	(request) => `/api/v3/setup-audit-trail?${getQueryString(request).replace('%23', ' ')}`
);
